import { SUB_CENTER_VALUES } from '@/constants/subCenter';

const SUB_CENTER_PATH_PATTERN = new RegExp(`/(${SUB_CENTER_VALUES.join('|')})(?=/|$)`);

/**
 * 去掉 URL 中的子中心路径段，便于 API 前缀与路由上下文解析。
 * 子中心加入后路径形如 `/data-center/:cluster/ops-center/...`，需剥离后再按原规则解析。
 */
export function stripSubCenterFromPathname(pathname: string): string {
  return pathname.replace(SUB_CENTER_PATH_PATTERN, '');
}

/** 获取用于上下文解析的 pathname（已去除子中心段） */
export function getPathnameForContextParsing(pathname: string = window.location.pathname): string {
  return stripSubCenterFromPathname(pathname);
}
